import { NgModule } from "@angular/core";
import { AlertSharedModule } from "@app2/alert/alert-shared/alert-shared.module";
import { SearchSharedModule } from "@app2/search/search-shared/search-shared.module";
import { TicketSharedModule } from "@app2/ticket/shared/ticket-shared.module";
import { AlertConditionsBlockComponent } from "@app2/triggers/alert-conditions-block.component";
import { TriggerDeleteModalComponent } from "@app2/triggers/trigger-delete-modal.component";
import { TriggerDescriptionDisplayComponent } from "@app2/triggers/trigger-description-display.component";
import {
    TriggerAggregationSelectorComponent
} from "@app2/triggers/trigger-edit-page/trigger-aggregation-selector.component";
import { TriggerConfigurationComponent } from "@app2/triggers/trigger-edit-page/trigger-configuration.component";
import { TriggerEmbeddedListComponent } from "@app2/triggers/trigger-embedded-list.component";
import { TriggerListModalComponent } from "@app2/triggers/trigger-list-modal.component";
import { TriggerPauseControlComponent } from "@app2/triggers/trigger-pause-control.component";
import { CardinalityErrorComponent } from "@app2/triggers/cardinality-error.component";
import { ActionOnByComponent } from "@app2/triggers/action-on-by.component";
import { TriggerPauseModalComponent } from "@app2/triggers/trigger-pause-modal.component";
import { TriggerQueryDisplayComponent } from "@app2/triggers/trigger-query-display.component";
import { TriggerSelectionModalComponent } from "@app2/triggers/trigger-selection-modal.component";
import { FormsModule } from "@angular/forms";
import { TriggerThresholdSelectorComponent } from "@app2/triggers/trigger-threshold-selector.component";
import { TriggerStatusNotificationComponent } from "@app2/triggers/trigger-status-notification.component";
import { SharedModule } from "@app2/shared/shared.module";
import { CommonModule } from "@angular/common";
import { TagSharedModule } from "@app2/tag/tag-shared-module";
import { TriggerGraphComponent } from "@app2/triggers/trigger-graph.component";
import { TriggerGraphLegendComponent } from "@app2/alert/alert-shared/trigger-graph-legend.component";
import { TriggerScheduleSharedModule } from "@app2/trigger-schedules/trigger-schedule-shared.module";
import { TriggerStatsPanelComponent } from "@app2/triggers/trigger-stats-panel.component";
import { UbaRiskFactorsComponent } from "@app2/triggers/uba-risk-factors.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        TicketSharedModule,
        TagSharedModule,
        TriggerScheduleSharedModule,
        SearchSharedModule,
        AlertSharedModule,
    ],
    declarations: [
        TriggerEmbeddedListComponent,
        TriggerThresholdSelectorComponent,
        CardinalityErrorComponent,
        TriggerGraphComponent,
        TriggerGraphLegendComponent,
        TriggerPauseModalComponent,
        TriggerStatusNotificationComponent,
        ActionOnByComponent,
        TriggerStatsPanelComponent,
        TriggerDeleteModalComponent,
        TriggerPauseControlComponent,
        TriggerConfigurationComponent,
        TriggerAggregationSelectorComponent,
        UbaRiskFactorsComponent,
        TriggerDescriptionDisplayComponent,
        TriggerQueryDisplayComponent,
        AlertConditionsBlockComponent,

        // Modals
        TriggerListModalComponent,
        TriggerSelectionModalComponent,
    ],
    exports: [
        ActionOnByComponent,
        TriggerEmbeddedListComponent,
        TriggerGraphComponent,
        TriggerGraphLegendComponent,
        TriggerPauseControlComponent,
        TriggerStatsPanelComponent,
        CardinalityErrorComponent,
        TriggerThresholdSelectorComponent,
        TriggerConfigurationComponent,
        TriggerAggregationSelectorComponent,
        UbaRiskFactorsComponent,
        TriggerDescriptionDisplayComponent,
        TriggerQueryDisplayComponent,
        AlertConditionsBlockComponent,
    ],
})
export class TriggersSharedModule {
    constructor() {
    }
}
